import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './FacultyProfileDetails.css'; // Import the new CSS file

const FacultyProfileDetails = () => {
    const [facultyData, setFacultyData] = useState(null);
    const [error, setError] = useState(null);
    const { facultyUsername } = useParams();
console.log(facultyUsername)
    useEffect(() => {
        fetch(`http://121.52.154.120:3001/api/faculty/${facultyUsername}`)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                setFacultyData(data);
            })
            .catch(error => {
                console.error('Fetch error:', error);
                setError(error.toString());
            });
    }, [facultyUsername]);

    const renderPublications = () => {
        if (!facultyData || !facultyData.publications || facultyData.publications.length === 0) {
            return <p>No publications available.</p>;
        }

        const groupedByType = facultyData.publications.reduce((acc, publication) => {
            const { publication_type } = publication;
            acc[publication_type] = acc[publication_type] || [];
            acc[publication_type].push(publication);
            return acc;
        }, {});

        return Object.entries(groupedByType).map(([type, publications]) => (
            <div key={type}>
                <h3 className="publication-category-heading">{type.charAt(0).toUpperCase() + type.slice(1)}</h3>
                <ul className="publication-list">
                    {publications.map((pub, index) => (
                        <li key={index} className="publication-item">{pub.details}</li>
                    ))}
                </ul>
            </div>
        ));
    };

    if (error) {
        return <div>Error: {error}</div>;
    }

    if (!facultyData) {
        return <div>Loading...</div>;
    }

    return (
        <div className='faculty-detail'>
            <header className='height-100'>
                <div className='container h-10 d-flex flex-column align-items-center justify-content-center text-light'>
                    <h1 className='text-center fw-semibold'>{facultyData.name}</h1>
                </div>
            </header>
            <div className='container my-12'>
                <div className='faculty-profile-container2'>
                    <div className="brief-details1">
                        <div className="brief-top d-flex align-items-center">
                            {facultyData?.fimages && (
                                <img src={`http://121.52.154.120:3001${facultyData.fimages}`} alt="Faculty" className="faculty-image1" />
                            )}
                            <div>
                                <h2 className="faculty-name1">{facultyData.name}</h2>
                                <p className="faculty-designation1"><strong>{facultyData.designation}</strong></p>
                                <p className="faculty-department1"><strong>{facultyData.department}</strong></p>
                            </div>
                        </div>
                        <div className="brief-bottom1">
    <p className="contact-info1">{facultyData.currentPortfolio}</p>

    <div className="contact-info1">
        <i className="fas fa-envelope"></i>
        <span className="contact-text1">
            <a href={`mailto:${facultyData.email}`}>{facultyData.email}</a>
        </span>
    </div>

    <div className="contact-info1">
        <i className="fas fa-phone"></i>
        <span className="contact-text1">{facultyData.phoneNumber}</span>
    </div>

    <div className="contact-info1">
        <i className="fas fa-clock"></i> {/* Added icon for Office Hours */}
        <span className="contact-text1">
            <strong>Office Hours:</strong> {facultyData.officeHours}
        </span>
    </div>

    <p className="profile-links1">
        {facultyData.GoogleScholar && (
            <a href={facultyData.GoogleScholar} target="_blank" rel="noopener noreferrer">
                <i className="bi bi-journal"></i> Google Scholar
            </a>
        )}
    </p>
    <p className="profile-links1">
        {facultyData.Scopus && (
            <a href={facultyData.Scopus} target="_blank" rel="noopener noreferrer">
                <i className="bi bi-journal-medical"></i> Scopus
            </a>
        )}
    </p>
    <p className="profile-links1">
        {facultyData.ORCID && (
            <a href={facultyData.ORCID} target="_blank" rel="noopener noreferrer">
                <i className="bi bi-person-badge"></i> ORCID
            </a>
        )}
    </p>
    <p className="profile-links1">
        {facultyData.LinkedIn && (
            <a href={facultyData.LinkedIn} target="_blank" rel="noopener noreferrer">
                <i className="bi bi-linkedin"></i> LinkedIn
            </a>
        )}
    </p>
    <p className="profile-links1">
        {facultyData.personalWebsite && (
            <a href={facultyData.personalWebsite} target="_blank" rel="noopener noreferrer">
                Personal Website
            </a>
        )}
    </p>
</div>

                    </div>
                    <div className="details-section1">
                        <p><strong>Biography:</strong> <span className="multiline-text1">{facultyData.objectives}</span></p>
                        <hr />

                        <p><strong>Qualification:</strong> {facultyData.qualification}</p>
                        <hr />
                        <p><strong>Professional Skills:</strong> <span className="multiline-text1">{facultyData.professionalSkills}</span></p>
                        <hr />
                        <p><strong>Current Research Interests:</strong> {facultyData.currentResearchInterests}</p>
                        <hr />
                        <p><strong>Proposed Research Topics:</strong> <span className="multiline-text1">{facultyData.proposedResearchTopics}</span></p>
                        <hr />
                        <p><strong>Research Impact:</strong> <span className="multiline-text1">{facultyData.researchImpact}</span></p>
                        <hr />
                        <h3>Publications</h3>
                        <ul>{renderPublications()}</ul>
                        <hr />
                        <p><strong>Funded Projects:</strong> <span className="multiline-text1">{facultyData.fundedProjects}</span></p>
                        <hr />
                        <p><strong>Patents:</strong> <span className="multiline-text1">{facultyData.patents}</span></p>
                        <hr />
                        <p><strong>Courses Currently Teaching:</strong> <span className="multiline-text1">{facultyData.coursesCurrentlyTeaching}</span></p>
                        <hr />
                        <p><strong>Courses Taught Previously:</strong> <span className="multiline-text1">{facultyData.coursesTaughtPreviously}</span></p>
                        <hr />
                        <p><strong>Supervised Completed Theses:</strong> <span className="multiline-text1">{facultyData.supervisedCompletedTheses}</span></p>
                        <hr />
                        <p><strong>Currently Supervising Theses:</strong> <span className="multiline-text1">{facultyData.currentlySupervisingTheses}</span></p>
                        <hr />
                        <p><strong>Professional Memberships:</strong> <span className="multiline-text1">{facultyData.professionalMemberships}</span></p>
                        <hr />
                        <p><strong>Awards & Distinctions:</strong> <span className="multiline-text1">{facultyData.awardsDistinctions}</span></p>
                        <hr />
                        <p><strong>Nominations:</strong> <span className="multiline-text1">{facultyData.nominations}</span></p>
                        <hr />
                        <p><strong>Professional Certificates:</strong> <span className="multiline-text1">{facultyData.professionalCertificates}</span></p>
                        <hr />
                        <p><strong>Volunteer Work:</strong> <span className="multiline-text1">{facultyData.volunteerWork}</span></p>
                        <hr />
                        <p><strong>Diplomas:</strong> {facultyData.diplomas}</p>
                        <hr />
                        <p><strong>Other Distinctions:</strong> <span className="multiline-text1">{facultyData.otherDistinctions}</span></p>
                        <hr />
                        <p><strong>Personal Interests:</strong> <span className="multiline-text1">{facultyData.personalInterests}</span></p>
                        <hr />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FacultyProfileDetails;
